import { useEffect } from "react";
// logo
import appLogo from "../../assets/png/HRZyra-White-Logo.png";

export const SplashScreen = ({ setLoading, hide }) => {

    useEffect(() => {
        const hasVisited = sessionStorage.getItem("hasVisited");

        if (hasVisited) {
            setLoading(false); // Skip splash screen
        } else {
            sessionStorage.setItem("hasVisited", "true"); // Set flag
            setTimeout(() => {
                setLoading(false);
            }, 4500); // Show splash for 2s
        }
    }, []);

    return (
        <div
            className={`splash-container ${hide ? "hidden" : ""
                } flex items-center justify-center h-screen bg-[#01b4ae]`}
        >
            <img
                src={appLogo}
                alt="App Logo"
                className="w-52 h-auto object-contain animate-bounce"
            />
        </div>
    );
};